import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { InvoiceLine } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-import-invoice-lines-dialog',
    templateUrl: './import-invoice-lines-dialog.component.html',
    styleUrls: ['./import-invoice-lines-dialog.component.scss'],
    standalone: false,
})
export class ImportInvoiceLinesDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    dealerId: number;
    invoiceLines: InvoiceLine[];
    onExporting = SharedModule.onExporting;

    @ViewChild('linesGrid') linesGrid: DxDataGridComponent;

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        const invoiceLines = (await this.uow.getInvoiceLinesByDealerId(
            this.dealerId,
            'invoice, orderLineDetail.orderLine.part.partPartTypes',
        )) as InvoiceLine[];
        this.invoiceLines = invoiceLines.filter((line) => line.quantity >= 0);
        this.appInfo.pleaseWaitHide();
    }

    hasSelection(): boolean {
        return !!this.linesGrid?.instance?.getSelectedRowsData?.()?.length;
    }

    add() {
        if (!this.hasSelection()) return;
        const selectedLines = this.linesGrid.instance.getSelectedRowsData();
        this.result.next({ success: true, invoiceLines: selectedLines });
        this.modalRef.hide();
    }

    close() {
        this.result.next(false);
        this.modalRef.hide();
    }
}
